// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_1ukoX","button":"view-header_button_3RF1p","active":"view-header_active_ugs7T","btnExport":"view-header_btnExport_3Qh6T","mr":"view-header_mr_phMFb"};